export class GetIndicatorsByStrategyIdRequestModel {
  constructor(public assessmentId: string, public strategyId: string) {
    this.assessmentId = assessmentId;
    this.strategyId = strategyId;
  }
}
